import { Component, OnInit } from '@angular/core';
import { EnforcementService } from 'src/app/Services/enforcement.service';
import { PermissionsService } from 'src/app/Services/permissions.service';
import { DataListFilterColumn, DatalastviewTextAndConditionalSuffixColumn, Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-citationreasons',
    templateUrl: './citationreasons.component.html',
    styleUrls: ['./citationreasons.component.scss'],
    standalone: false
})
export class CitationReasonsComponent implements OnInit {
  constructor(private permissionsService: PermissionsService, public enforcementService: EnforcementService) { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn('Id', 'Id'),
    new Datalistviewcolumn('Name', 'Name'),
    new Datalistviewcolumn('Description', 'Description'),
    new Datalistviewcolumn('Base Fine', 'BaseFine'),
  ];

  async ngOnInit(): Promise<void> {
  }
} 
